import { render, staticRenderFns } from "./Maixueyuan.vue?vue&type=template&id=364c96e4&scoped=true&"
import script from "./Maixueyuan.vue?vue&type=script&lang=js&"
export * from "./Maixueyuan.vue?vue&type=script&lang=js&"
import style0 from "./Maixueyuan.vue?vue&type=style&index=0&id=364c96e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364c96e4",
  null
  
)

export default component.exports